function isDatetime(prop) {
  return typeof prop === 'string' && !isNaN(new Date(prop).getTime());
}

export default function(propValue, key, componentName) {
  if (!isDatetime(propValue[key])) {
    return new Error(`${propValue[key]} supplied to ${componentName} is not a datetime value. Validation failed.`);
  }
}
